import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export interface HierarchyLevelDTO {
	group: string | { _id: string; name: string } | null;
}

export interface HierarchyDTO {
	_id: string;
	name: string;
	role: string;
	description: string;
	farmer: HierarchyLevelDTO;
	consultant: HierarchyLevelDTO;
	company: HierarchyLevelDTO;
	master: HierarchyLevelDTO;
}

export interface PaginatedHierarchiesResponse {
	docs: HierarchyDTO[];
	totalDocs: number;
	limit: number;
	totalPages: number;
	page: number;
}

export interface UseGetHierarchiesParams {
	page?: number;
	limit?: number;
	enabled?: boolean;
}

export function useGetHierarchies({
	page = 1,
	limit = 1000,
	enabled = true,
}: UseGetHierarchiesParams = {}) {
	const query = useQuery<PaginatedHierarchiesResponse>({
		queryKey: ['hierarchies', page, limit],
		enabled,
		queryFn: async () => {
			const { data } = await api.get<PaginatedHierarchiesResponse>('/hierarchy/findAll', {
				params: { page, limit },
			});
			return data;
		},
	});

	return {
		...query,
		data: query.data?.docs ?? [],
		pagination: query.data
			? { totalDocs: query.data.totalDocs, totalPages: query.data.totalPages, page: query.data.page }
			: null,
	};
}
